import BaseClient from '../base-client';

// /user_data/user/:userId/property/:property/

export default class RemotePreferencesClient extends BaseClient {
  constructor(opts) {
    super('/user_data/user', {
      ...opts,
      format: (response) => response,
    });
  }

  async setPreference(contactUUID, preferenceName, preferenceValue) {
    let value = preferenceValue;
    if (typeof preferenceValue === 'boolean') {
      value = preferenceValue ? '1' : '0';
    }
    const response = await this.request('post', `${contactUUID}/property/${preferenceName}`)({
      user_data: value,
    });

    console.log('setPreference response', response);

    return response;
  }
}
